// Filename: srt-report.js
// Purpose: Handles modal show/hide for report meta fields and date autofill
import { VEHICLE_TYPE_RULES } from '../../common/srt/srt-common-presets.js';
import html2canvas from 'html2canvas';

export function initReport() {
   const $toggleMetaSwitch = $('#toggle-report-meta');
   const $metaFields = $('#report-meta-fields');
   // Prefill today's date on page load if empty
   const $reportDate = $('#report-date');
   if ($reportDate.length && !$reportDate.val()) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      $reportDate.val(`${yyyy}-${mm}-${dd}`);
   }

   // Toggle meta fields section with the switch
   $toggleMetaSwitch.on('change', function () {
      if (this.checked) {
         $metaFields.removeClass('d-none');
      } else {
         $metaFields.addClass('d-none');
      }
   });

   $(function () {
      $('#view-report-summary-btn').on('click', showReportDialog);
      // $('#close-report-dialog-btn').on('click', hideReportDialog);
   });

   initReportHandlers();
}

export function initReportHandlers() {
   $('#btn-screenshot').on('click', () => {
      const modal = document.querySelector('#report-summary-content');
      html2canvas(modal, { scale: 2 }).then((canvas) => {
         const link = document.createElement('a');
         link.download = 'srt-report.png';
         link.href = canvas.toDataURL('image/png');
         link.click();
      });
   });

   $('#btn-export-csv').on('click', () => {
      const lines = [];

      // --- Section: Report Summary ---
      lines.push(['--- Report Summary ---']);
      lines.push(['SRT (g)', $('#report-srt-result').text()]);
      lines.push(['Tilt Angle (deg)', $('#report-tilt-angle').text().replace(/°/g, '')]);
      lines.push(['Result Status', $('#report-srt-result-badge').text()]);
      lines.push([]);

      // --- Section: Metadata ---
      lines.push(['--- Report Metadata ---']);
      lines.push(['Company Name', $('#meta-company').text()]);
      lines.push(['Vehicle ID / Asset', $('#meta-asset').text()]);
      lines.push(['Report Date', $('#meta-date').text()]);
      lines.push(['Notes', $('#meta-notes').text().replace(/\n/g, ' ')]);
      lines.push([]);

      // --- Section: Vehicle Summary ---
      lines.push(['--- Vehicle Summary ---']);
      lines.push(['Vehicle Type', $('#vehicle-type').text()]);
      lines.push(['Front Axles', $('#front-axles').text()]);
      lines.push(['Rear Axles', $('#rear-axles').text()]);
      lines.push(['Gross Mass (kg)', $('#total-gross-mass').text().replace(/,/g, '')]);
      lines.push(['Payload Mass (kg)', $('#total-payload-mass').text().replace(/,/g, '')]);
      lines.push(['Tare Mass (kg)', $('#total-tare-mass').text().replace(/,/g, '')]);

      lines.push(['Front Suspension', $('#front-suspension').text()]);
      lines.push(['Rear Suspension', $('#rear-suspension').text()]);
      lines.push(['Load Category', $('#load-type').text()]);
      lines.push(['Body Style', $('#body-style').text()]);
      lines.push(['Calculated SRT', $('#calculated-srt').text()]);
      lines.push([]);

      // --- Section: Front/Rear Inputs Table ---
      lines.push(['--- Input Table (Front vs Rear) ---']);
      lines.push(['Field', 'Front', 'Rear']);

      $('#input-table-front-rear tr').each(function () {
         const cells = $(this)
            .find('td')
            .map((_, el) => $(el).text().replace(/,/g, '')) // avoid commas inside CSV
            .get();
         lines.push(cells);
      });

      // Build and download CSV
      const csv = lines.map((line) => line.join(',')).join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'srt-report.csv';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
   });
   $('#btn-better-print').on('click', () => {
      const modalHTML = document.querySelector('#report-summary-content').outerHTML;
      const printWindow = window.open('', '', 'width=1024,height=768');
      // Build a string with current date and time in local format
      const now = new Date();
      const dateStr = now.toLocaleDateString('en-AU', {
         year: 'numeric',
         month: '2-digit',
         day: '2-digit',
         hour: '2-digit',
         minute: '2-digit',
         hour12: false,
      });

      printWindow.document.write(`
      <html><head>
        <title>SRT Calculator Report Summary</title>
        <link rel="stylesheet" href="/bootstrap-5.2.3-dist/css/bootstrap.min.css">
        <style>body { padding: 2rem; font-family: sans-serif; }</style>
      </head><body>
      <h1 class="text-center mb-4">SRT Calculator Report Summary</h1>
      <p class="text-center text-muted">Generated on: ${dateStr}</p>
        ${modalHTML}
        <script>window.onload = () => window.print();</script>
      </body></html>
    `);
      printWindow.document.close();
   });
}

function showReportDialog() {
   // Handle meta field toggle and date autofill as before
   $('#toggle-report-meta').prop('checked', false);
   $('#report-meta-fields').addClass('d-none');

   const $reportDate = $('#report-date');
   if ($reportDate.length && !$reportDate.val()) {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0');
      const dd = String(today.getDate()).padStart(2, '0');
      $reportDate.val(`${yyyy}-${mm}-${dd}`);
   }

   // Collect data and render
   const unitIndex = 0;
   const inputData = collectInputData(unitIndex);
   const resultData = window.srtReportResults[unitIndex] || {};
   renderReportSummary(inputData, resultData);

   // Show the Bootstrap modal
   const modalEl = document.getElementById('reportSummaryModal');
   if (modalEl) {
      // For Bootstrap 5, use the Modal class
      if (window.bootstrap && window.bootstrap.Modal) {
         const modal = bootstrap.Modal.getOrCreateInstance(modalEl);
         modal.show();
      } else if (typeof $ !== 'undefined' && typeof $('#reportSummaryModal').modal === 'function') {
         // Fallback for Bootstrap 4 or jQuery plugin
         $('#reportSummaryModal').modal('show');
      } else {
         console.error('Bootstrap modal JS not loaded.');
      }
   }
}

function hideReportDialog() {
   const $modal = $('#reportSummaryModal');
   if ($modal.length) {
      $modal.modal('hide');
   }
}

/**
 * Renders the SRT report summary modal using collected input and result data.
 * @param {object} inputData - Data from collectInputData()
 * @param {object} resultData - Data from renderResults() or collectResultData()
 */
export function renderReportSummary(inputData, resultData) {
   // --- Helper functions ---
   // Safely escape HTML (for notes, etc.)
   function esc(str) {
      return String(str || '').replace(
         /[&<>"']/g,
         (s) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[s])
      );
   }
   function orDash(val) {
      return val && val !== '' ? esc(val) : '—';
   }

   //console.log('Rendering SRT report summary with input data:', inputData);
   // --- Build meta (report details) table ---
   $('#meta-company').text(inputData.companyName || '—');
   $('#meta-asset').text(inputData.vehicleId || '—');
   $('#meta-date').text(inputData.reportDate || '—');
   $('#meta-notes').html(esc(inputData.notes).replace(/\n/g, '<br>') || '—');

   // --- Summary card (SRT/Tilt) ---
   $('#report-srt-result').text(orDash(resultData.srt));
   $('#report-tilt-angle').text(resultData.tiltAngle ? `${resultData.tiltAngle}` : '—');
   // Badge color and status
   const $badge = $('#report-srt-result-badge');
   $badge.removeClass('bg-secondary bg-danger bg-success');
   let statusLabel = orDash(resultData.passFail);
   if (statusLabel.toLowerCase().includes('compliant')) {
      $badge.addClass('bg-success');
   } else if (statusLabel.toLowerCase().includes('fail') || statusLabel.toLowerCase().includes('error')) {
      $badge.addClass('bg-danger');
   } else {
      $badge.addClass('bg-secondary');
   }
   $badge.text(statusLabel);

   // --- Vehicle/Calculation summary ---
   const hasFrontAxles = parseInt(inputData.frontAxles, 10) > 0;
   const payloadMassFront = hasFrontAxles ? parseFloat(inputData.payloadMassFront) || 0 : 0;
   const payloadMassRear = parseFloat(inputData.payloadMassRear) || 0;
   const tareMassFront = hasFrontAxles ? parseFloat(inputData.tareMassFront) || 0 : 0;
   const tareMassRear = parseFloat(inputData.tareMassRear) || 0;
   const grossMassFront = hasFrontAxles ? parseFloat(inputData.grossMassFront) || 0 : 0;
   const grossMassRear = parseFloat(inputData.grossMassRear) || 0;
   const totalPayloadMass = payloadMassFront + payloadMassRear;
   const totalTareMass = tareMassFront + tareMassRear;
   const totalGrossMass = grossMassFront + grossMassRear;
   const vt = inputData.vt; // or use a mapping if the form stores the label not code
   const icon = VEHICLE_TYPE_RULES[vt]?.icon || 'truck.svg';
   const iconPath = `/icons/${icon}`;
   $('#vehicle-type').text(orDash(inputData.vehicleType));
   $('#vehicle-type-icon')
      .attr('src', iconPath)
      .attr('alt', vt ? `${vt} icon` : 'Vehicle icon');

   $('#front-axles').text(orDash(inputData.frontAxles));
   $('#rear-axles').text(orDash(inputData.rearAxles));
   $('#total-gross-mass').text(totalGrossMass > 0 ? totalGrossMass.toLocaleString('en') : '—');
   $('#total-payload-mass').text(totalPayloadMass > 0 ? totalPayloadMass.toLocaleString('en') : '—');
   $('#total-tare-mass').text(totalTareMass > 0 ? totalTareMass.toLocaleString('en') : '—');
   $('#front-suspension').text(orDash(inputData.suspensionTypeFront));
   $('#rear-suspension').text(orDash(inputData.suspensionTypeRear));
   $('#load-type').text(orDash(inputData.loadCategory));
   $('#body-style').text(orDash(inputData.deckStyle));
   $('#calculated-srt').text(resultData.srt ? `${resultData.srt} g` : '—');

   // --- Status/advice block ---
   let statusMsg = '';
   if (resultData.srt && resultData.srtTarget) {
      statusMsg =
         +resultData.srt >= +resultData.srtTarget
            ? `<span class="text-success fw-bold">Compliant:</span> Vehicle meets or exceeds target SRT (${resultData.srtTarget}).`
            : `<span class="text-danger fw-bold">Not Compliant:</span> SRT below target (${resultData.srtTarget}).`;
   } else if (resultData.passFail) {
      statusMsg = esc(resultData.passFail);
   }
   if (resultData.messages && resultData.messages.length) {
      statusMsg += '<br><span class="text-warning">' + 'Warning: ' + '</span>' + resultData.messages.join('<br>');
   }
   $('#status-summary').html(statusMsg);

   // prepare payload geometry rows based on deck style
   let payloadGeometryRows = [];
   if (inputData.deckStyle && inputData.deckStyle.toLowerCase().includes('standard')) {
      payloadGeometryRows = [
         ['Deck Style', orDash(inputData.deckStyle), orDash(inputData.deckStyle)],
         ['Load Bed Height (m)', orDash(inputData.loadBedHeight), orDash(inputData.loadBedHeight)],
         ['Load Height Max (m)', orDash(inputData.loadHeightMax), orDash(inputData.loadHeightMax)],
      ];
   } else if (inputData.deckStyle && inputData.deckStyle.toLowerCase().includes('step')) {
      payloadGeometryRows = [
         ['Deck Style', orDash(inputData.deckStyle), orDash(inputData.deckStyle)],
         ['Deck Height (m)', orDash(inputData.deck1Height), orDash(inputData.deck2Height)],
         ['Deck Length (m)', orDash(inputData.deck1Length), orDash(inputData.deck2Length)],
         ['Load Height Max (m)', orDash(inputData.deckLoadHeight), orDash(inputData.deckLoadHeight)],
      ];
   } else if (inputData.deckStyle && inputData.deckStyle.toLowerCase().includes('sloping')) {
      payloadGeometryRows = [
         ['Deck Style', orDash(inputData.deckStyle), orDash(inputData.deckStyle)],
         ['Load Bed Height (m)', orDash(inputData.loadBedHeightFront), orDash(inputData.loadBedHeightRear)],
         ['Load Height (m)', orDash(inputData.loadHeightFront), orDash(inputData.loadHeightRear)],
      ];
   }
   // --- Front/Rear grouped table ---
   let frontRearRows = [
      ['__SPACE__', '', ''],

      ['Gross Mass (kg)', inputData.grossMassFront, inputData.grossMassRear],
      ['Tare Mass (kg)', inputData.tareMassFront, inputData.tareMassRear],
      ['Unsprung Mass (per axle, kg)', inputData.unsprungMassFront, inputData.unsprungMassRear],
      ['Unsprung CoG Height (m)', inputData.unsprungCGHeightFront, inputData.unsprungCGHeightRear],
      ['Sprung Tare Mass (kg)', inputData.sprungTareFront, inputData.sprungTareRear],
      ['Sprung Tare Mass CoG Height (m)', inputData.sprungCGHeight, inputData.sprungCGHeight],
      ['__SPACE__', '', ''],

      ['Payload Mass (kg)', inputData.payloadMassFront, inputData.payloadMassRear],
      ['Payload Mass CoG Height (m)', inputData.currentPayloadCog, inputData.currentPayloadCog],
      ['__SPACE__', '', ''],

      ['Tyre Size', inputData.tyreSizeFront, inputData.tyreSizeRear],
      ['Tyre Configuration', inputData.tyreConfigFront, inputData.tyreConfigRear],
      ['Ground Contact Width (m)', inputData.maxContactWidthFront, inputData.maxContactWidthRear],
      ['__SPACE__', '', ''],

      ['Spring Spacing (m)', inputData.fSpringSpacing, inputData.rSpringSpacing],
      ['Spring Stiffness (N/m)', inputData.fSpringStiffness, inputData.rSpringStiffness],
      ['Roll Stiffness (Nm/rad)', inputData.fRollStiffness, inputData.rRollStiffness],
      ['Aux Roll Stiffness (Nm/rad)', inputData.fAuxStiffness, inputData.rAuxStiffness],
      ['Track Width (m)', inputData.fTrackWidth, inputData.rTrackWidth],
      ['Lash (mm)', inputData.fLash, inputData.rLash],
      ['Roll Center Height (m)', inputData.fRollCenterHeight, inputData.rRollCenterHeight],
   ];
   frontRearRows = payloadGeometryRows.concat(frontRearRows);

   let tableRows = '';
   for (const [label, front, rear] of frontRearRows) {
      if (label === '__SPACE__') {
         tableRows += `<tr class="spacer-row"><td colspan="3"></td></tr>`;
         continue;
      }

      // If no front axles, always show dash in Front column
      const frontValue = hasFrontAxles ? orDash(front) : '—';
      tableRows += `<tr>
    <td>${esc(label)}</td>
    <td>${frontValue}</td>
    <td>${orDash(rear)}</td>
  </tr>`;
   }
   $('#input-table-front-rear').html(tableRows);

   // (Extend here for more fields, step/sloping decks, etc.)
}

/**
 * Collects all main SRT input values from the form for the specified unit index.
 * Returns a plain JS object suitable for the report.
 * @param {number} unitIndex
 * @returns {object}
 */
export function collectInputData(unitIndex = 0) {
   // Helper for getting value or fallback
   function val(id, def = '') {
      const $el = $('#' + id);
      if (!$el.length) return def;
      if ($el.is('select')) return $el.find('option:selected').text() || def;
      return $el.val() || def;
   }

   // Main section: Vehicle
   const vehicleType = val(`vehicle-type-${unitIndex}`);
   const vt = $(`#vehicle-type-${unitIndex}`).val();
   const frontAxles = val(`front-axles-${unitIndex}`);
   const rearAxles = val(`rear-axles-${unitIndex}`);

   // Tyres (front and rear)
   const tyreSizeFront = val(`f-tyre-size-${unitIndex}`);
   const tyreConfigFront = val(`f-tyre-config-${unitIndex}`);
   const tyreSizeRear = val(`r-tyre-size-${unitIndex}`);
   const tyreConfigRear = val(`r-tyre-config-${unitIndex}`);

   // Axle loads (front and rear)
   const grossMassFront = val(`f-gross-mass-${unitIndex}`);
   const tareMassFront = val(`f-tare-mass-${unitIndex}`);
   const payloadMassFront = val(`f-payload-mass-${unitIndex}`);
   const grossMassRear = val(`r-gross-mass-${unitIndex}`);
   const tareMassRear = val(`r-tare-mass-${unitIndex}`);
   const payloadMassRear = val(`r-payload-mass-${unitIndex}`);

   // Unsprung mass/CG
   const unsprungMassFront = val(`f-unsprung-mass-${unitIndex}`, 'Used default'); // axle mass
   const unsprungMassFrontTotal = val(`f-unsprung-mass-total-${unitIndex}`, 'Used default');
   const unsprungCGHeightFront = val(`f-unsprung-cg-height-${unitIndex}`, 'Used default');
   const maxContactWidthFront = val(`f-max-contact-width-${unitIndex}`, 'Used default');
   const unsprungMassRear = val(`r-unsprung-mass-${unitIndex}`, 'Used default'); // axle mass
   const unsprungMassRearTotal = val(`r-unsprung-mass-total-${unitIndex}`, 'Used default');
   const unsprungCGHeightRear = val(`r-unsprung-cg-height-${unitIndex}`, 'Used default');
   const maxContactWidthRear = val(`r-max-contact-width-${unitIndex}`, 'Used default');

   // Sprung Mass (advanced)
   const sprungCGHeight = val(`sprung-cg-height-${unitIndex}`, 'Used default');
   const sprungTareMass = val(`sprung-tare-mass-${unitIndex}`);
   const sprungTareFront = tareMassFront - unsprungMassFrontTotal;
   const sprungTareRear = tareMassRear - unsprungMassRearTotal;

   // Payload Geometry
   const deckStyle = val(`deck-style-${unitIndex}`);
   const loadBedHeight = val(`load-bed-height-${unitIndex}`);
   let loadHeightMax = val(`load-height-max-${unitIndex}`);
   const loadHeightFront = val(`load-height-front-${unitIndex}`, 'NA');
   const loadHeightRear = val(`load-height-rear-${unitIndex}`, 'NA');
   const loadBedHeightFront = val(`load-bed-height-front-${unitIndex}`, 'NA');
   const loadBedHeightRear = val(`load-bed-height-rear-${unitIndex}`, 'NA');
   const deck1Height = val(`deck1-height-${unitIndex}`, 'NA');
   const deck2Height = val(`deck2-height-${unitIndex}`, 'NA');
   const deck1Length = val(`deck1-length-${unitIndex}`, 'NA');
   const deck2Length = val(`deck2-length-${unitIndex}`, 'NA');
   const deckLoadHeight = val(`deck-load-height-max-${unitIndex}`);

   // Payload Distribution/CG
   const loadCategory = val(`load-category-${unitIndex}`);
   const payloadCGHeight = val(`payload-cg-height-${unitIndex}`, 'Used default');

   // Suspension
   const suspensionTypeFront = val(`suspension-type-front-${unitIndex}`);
   const suspensionTypeRear = val(`suspension-type-rear-${unitIndex}`);
   const fSpringSpacing = val(`f-spring-spacing-${unitIndex}`);
   const fLash = val(`f-lash-${unitIndex}`);
   const fRollStiffness = val(`f-roll-stiffness-${unitIndex}`);
   const fSpringStiffness = val(`f-spring-stiffness-${unitIndex}`);
   const fRollCenterHeight = val(`f-roll-center-height-${unitIndex}`);

   const rSpringSpacing = val(`r-spring-spacing-${unitIndex}`);
   const rLash = val(`r-lash-${unitIndex}`);
   const rRollStiffness = val(`r-roll-stiffness-${unitIndex}`);
   const rSpringStiffness = val(`r-spring-stiffness-${unitIndex}`);
   const rRollCenterHeight = val(`r-roll-center-height-${unitIndex}`);

   const fAuxStiffness = val(`f-aux-stiffness-${unitIndex}-rad`, 'NA');
   const rAuxStiffness = val(`r-aux-stiffness-${unitIndex}-rad`, 'NA');
   const fTrackWidth = val(`f-track-width-${unitIndex}`, 'NA');
   const rTrackWidth = val(`r-track-width-${unitIndex}`, 'NA');

   // Other
   const currentPayloadCog = window.currentPayloadCog; // Use global returned from srt result

   // Compose the data object
   return {
      vehicleType,
      vt,
      frontAxles,
      rearAxles,

      tyreSizeFront,
      tyreConfigFront,
      tyreSizeRear,
      tyreConfigRear,

      grossMassFront,
      tareMassFront,
      payloadMassFront,
      grossMassRear,
      tareMassRear,
      payloadMassRear,

      unsprungMassFront,
      unsprungCGHeightFront,
      maxContactWidthFront,
      unsprungMassRear,
      unsprungCGHeightRear,
      maxContactWidthRear,

      sprungCGHeight,
      sprungTareMass,
      sprungTareFront,
      sprungTareRear,

      deckStyle,
      loadBedHeight,
      loadHeightMax,
      loadHeightFront,
      loadHeightRear,
      loadBedHeightFront,
      loadBedHeightRear,
      deck1Height,
      deck2Height,
      deck1Length,
      deck2Length,
      deckLoadHeight,

      loadCategory,
      payloadCGHeight,

      suspensionTypeFront,
      suspensionTypeRear,

      fSpringSpacing,
      fLash,
      fRollStiffness,
      fSpringStiffness,
      fRollCenterHeight,
      rSpringSpacing,
      rLash,
      rRollStiffness,
      rSpringStiffness,
      rRollCenterHeight,
      fAuxStiffness,
      rAuxStiffness,
      fTrackWidth,
      rTrackWidth,

      currentPayloadCog,
   };
}
